import React from 'react';

const OPERATORS = [
  { value: 'equals', label: 'Equals' },
  { value: 'not_equals', label: 'Not equals' },
  { value: 'contains', label: 'Contains' },
  { value: 'not_contains', label: 'Not contains' },
  { value: 'is_empty', label: 'Is empty' },
  { value: 'is_not_empty', label: 'Is not empty' },
];

export default function ConditionalLogicBuilder({ value, onChange, fieldOptions }) {
  const logic = value || { action: 'show', operator: 'and', rules: [] };

  function updateRules(rules) {
    onChange({ ...logic, rules });
  }

  function updateRule(index, patch) {
    const next = logic.rules.map((r, i) => (i === index ? { ...r, ...patch } : r));
    updateRules(next);
  }

  return (
    <div className="space-y-3">
      <div className="text-xs font-semibold text-gray-600 dark:text-slate-400">Conditional Logic</div>
      <div className="flex gap-3">
        <select
          value={logic.action || 'show'}
          onChange={(e) => onChange({ ...logic, action: e.target.value })}
          className="px-3 py-2 border border-gray-300 dark:border-white/10 rounded-lg bg-white dark:bg-white/5 text-gray-900 dark:text-white"
        >
          <option value="show">Show</option>
          <option value="hide">Hide</option>
        </select>
        <select
          value={logic.operator || 'and'}
          onChange={(e) => onChange({ ...logic, operator: e.target.value })}
          className="px-3 py-2 border border-gray-300 dark:border-white/10 rounded-lg bg-white dark:bg-white/5 text-gray-900 dark:text-white"
        >
          <option value="and">All rules (AND)</option>
          <option value="or">Any rule (OR)</option>
        </select>
      </div>
      <div className="space-y-2">
        {logic.rules.map((rule, idx) => (
          <div key={`rule-${idx}`} className="grid grid-cols-1 md:grid-cols-3 gap-2">
            <select
              value={rule.fieldKey || ''}
              onChange={(e) => updateRule(idx, { fieldKey: e.target.value })}
              className="px-3 py-2 border border-gray-300 dark:border-white/10 rounded-lg bg-white dark:bg-white/5 text-gray-900 dark:text-white"
            >
              <option value="">Select field</option>
              {fieldOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
            <select
              value={rule.operator || 'equals'}
              onChange={(e) => updateRule(idx, { operator: e.target.value })}
              className="px-3 py-2 border border-gray-300 dark:border-white/10 rounded-lg bg-white dark:bg-white/5 text-gray-900 dark:text-white"
            >
              {OPERATORS.map((op) => (
                <option key={op.value} value={op.value}>
                  {op.label}
                </option>
              ))}
            </select>
            <input
              type="text"
              placeholder="Value"
              value={rule.value ?? ''}
              onChange={(e) => updateRule(idx, { value: e.target.value })}
              className="px-3 py-2 border border-gray-300 dark:border-white/10 rounded-lg bg-white dark:bg-white/5 text-gray-900 dark:text-white"
            />
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={() => updateRules([...(logic.rules || []), { fieldKey: '', operator: 'equals', value: '' }])}
        className="text-sm text-blue-600 hover:text-blue-700"
      >
        + Add Rule
      </button>
    </div>
  );
}


